import React from 'react';
import './with-app.scss';
import 'js-promo-partners-lib/lib/components/wordpress-plugin/wordpress-plugin.common.scss';

const WithApp = Component => (
    props => <Component {...props} />
);

export default WithApp;
